import React, { useEffect } from 'react';

const id = "coauthorRoot";

/**
 * Provides a mount point for the Co-Author React app
 * and mounts it when this component mounts.
 * 
 * Important: this component must be placed immediately after the CoauthorButton which controls it
 * so that the tab order is correct
 * and so that the button's "active" styles work correctly.
 */
export default function CoauthorRoot() {
  useEffect(() => {
    window.initOkrCoauthorComponent?.(id);
  },[])
  return <div id={id} />
}